module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Toggle.js"));
	}, "Toggle");
}